import { render, staticRenderFns } from "./editorAddPointsToolPopover.vue?vue&type=template&id=bc4a17ba&"
import script from "./editorAddPointsToolPopover.vue?vue&type=script&lang=js&"
export * from "./editorAddPointsToolPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports